@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }} @if (control && control.hasValidator(Validators.required)) {
    <span class="text-red-600">*</span>
  }
  </label>
}
<div class="relative">
  <input
    #datePicker
    [disabled]="control.disabled"
    (change)="$event.stopPropagation();changed($event)"
    (input)="onManualInput($event)"
    (blur)="onBlur()"
    [name]="name"
    [allowInput]="true"
    [dateFormat]="format"
    class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
    focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
    dark:focus:border-brand-800"
    [ngClass]="{ 'cursor-not-allowed opacity-60': control.disabled }"
    type="text"
    placeholder="dd/mm/yyyy"
    autocomplete="off"
    mwlFlatpickr
    [clickOpens]="!control.disabled"
    [disableMobile]="true"
  />
  <div class="absolute top-1/2 right-3 -translate-y-1/2 flex items-center gap-1">
    @if (control.value && !control.disabled) {
      <span
        (click)="$event.stopPropagation();clearDate()"
        class="cursor-pointer text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
        title="Clear date">
        <lucide-icon size="16" [name]="X"></lucide-icon>
      </span>
    }
    <span
      (click)="onCalendarClick($event, datePicker)"
      [ngClass]="{
        'text-error-500': control.invalid && (control.dirty || control.touched),
        'text-gray-500 dark:text-gray-400': !control.invalid || !(control.dirty || control.touched),
        'cursor-not-allowed opacity-60': control.disabled
      }"
      class="cursor-pointer"
      title="Open calendar">
      <lucide-icon size="18" [name]="Calendar"></lucide-icon>
    </span>
  </div>
</div>

@if (control.invalid && (control.dirty || control.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
      @if (control.errors) {
        <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
      }
    }
  </p>
}
